import React from 'react';
import ReactDOM from 'react-dom';
import CacheBuster from 'react-cache-buster';
import 'styles/index.scss';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from 'store';
import { theme } from 'styles/theme';
import Router from 'routes/Router';
import { Loading, ErrorBoundary, OfflinePage } from 'components';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { version } from '../package.json';
import { useNavigatorOnLine } from 'hooks';

const GlobalStyle = createGlobalStyle`
	${reset}
	html {
		background-color: #f7f7f7;
		margin: 0;
		font-family: 'Open Sans', sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
	body {
    margin: 0 auto;
	width: 100%;
    max-width: 480px;
	background-color: #fff;
	height: 100%;
	}
	.ant-modal-content {
		border-radius: 8px;
	}
`;

console.log(
	`%cWelcome to Ripplr Collection App v${`${version} - ${process.env.NODE_ENV} - ${process?.env?.REACT_APP_ENV}`}`,
	'background: #46C2B6; color: #113F5F; font-size: 12px'
);

const isProduction = process.env.NODE_ENV === 'production';

function AppRender() {
	const networkStatus = useNavigatorOnLine();

	return (
		<ErrorBoundary>
			<CacheBuster
				currentVersion={version}
				isEnabled={isProduction}
				isVerboseMode
				loadingComponent={<Loading />}
			>
				<Provider store={store}>
					<ThemeProvider theme={theme}>
						<GlobalStyle />
						{networkStatus ? (
							<BrowserRouter basename={process.env.PUBLIC_URL}>
								<Router />
							</BrowserRouter>
						) : (
							<OfflinePage />
						)}
					</ThemeProvider>
				</Provider>
			</CacheBuster>
		</ErrorBoundary>
	);
}

ReactDOM.render(<AppRender />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// to clear cache on production
// https://dev.to/ammartinwala52/clear-cache-on-build-for-react-apps-1k8j
// https://dev.to/flexdinesh/cache-busting-a-react-app-22lk
// https://github.com/flexdinesh/cache-busting-example
